import React from 'react';
import { Grid2, Box } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import LocationSvg from '/public/icons/location.svg?icon';
import JobSvg from '/public/icons/job.svg?icon';
import SimplifyImage from '/public/images/home/simplify.svg';
import PaymentImage from '/public/images/home/payment.svg';
import IconWithImage from 'components/IconWithImage';

const GetStarted = (): JSX.Element => {
  const t = useTranslations('Home');
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Grid2
      container
      display="flex"
      flexDirection="column"
      spacing={2}
      sx={{
        mt: {
          xs: 2,
          md: 4,
        },
      }}
    >
      <Grid2
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretched', sm: 'center' }}
        justifyContent={'center'}
        spacing={4}
        container
      >
        <Grid2
          data-aos={isMd ? 'fade-right' : 'fade-up'}
          size={{
            xs: 12,
            sm: 6,
          }}
          display={{
            xs: 'none',
            md: 'block',
          }}
        >
          <Image
            src={PaymentImage}
            alt="sailglobalHome"
            width={560}
            height={340}
          />
        </Grid2>
        <Grid2
          data-aos={isMd ? 'fade-left' : 'fade-up'}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Box
            sx={{
              fontSize: {
                xs: '32px',
                md: '40px',
              },
              fontWeight: 700,
            }}
          >
            {t('specialtyTitle')}
          </Box>
          <Box
            sx={{
              color: '#000',
              fontSize: {
                xs: '16px',
                md: '20px',
              },
              my: 3,
            }}
          >
            {t('specialtyDescription')}
          </Box>
          <Grid2 container spacing={2} size={12}>
            <Grid2
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <IconWithImage
                title={t('specialtyBtn')}
                icon={LocationSvg}
                iconSx={{
                  color: '#000',
                  fontSize: '32px',
                }}
                boxSx={{
                  background: '#FFE2D7',
                  width: '100%',
                  cursor: 'pointer',
                }}
                footerIconSx={{
                  color: 'inherit',
                  fill: 'currentcolor',
                  fontSize: '32px',
                }}
                href="/book-demo"
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretched', sm: 'center' }}
        justifyContent={'center'}
        spacing={4}
        container
        sx={{
          my: {
            xs: 2,
            md: 8,
          },
        }}
      >
        <Grid2
          data-aos={isMd ? 'fade-right' : 'fade-up'}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Box
            sx={{
              fontSize: {
                xs: '32px',
                md: '40px',
              },
              fontWeight: 700,
            }}
          >
            {t('solutionsTitle')}
          </Box>
          <Box
            sx={{
              color: '#000',
              fontSize: {
                xs: '16px',
                md: '20px',
              },
              my: 3,
            }}
          >
            {t('solutionsDescription')}
          </Box>
          <Grid2 container size={12} spacing={2}>
            <Grid2
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <IconWithImage
                title={t('solutionsBtn')}
                icon={JobSvg}
                iconSx={{
                  color: '#000',
                  fontSize: '32px',
                }}
                boxSx={{
                  background: '#DDF3E3',
                  width: '100%',
                  cursor: 'pointer',
                }}
                footerIconSx={{
                  color: 'inherit',
                  fill: 'currentcolor',
                  fontSize: '32px',
                }}
                href="/book-demo"
              />
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2
          data-aos={isMd ? 'fade-left' : 'fade-up'}
          size={{
            xs: 12,
            md: 6,
          }}
          display={{
            xs: 'none',
            md: 'block',
          }}
        >
          <Image
            src={SimplifyImage}
            alt="sailglobalHome image"
            width={560}
            height={340}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'cover',
            }}
          />
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default GetStarted;
